// eslint-disable-next-line import/prefer-default-export
export const COMPANIES_TRANSLATIONS = {
  Medtronic: 'Medtronic',
  Abbott: 'Abbott',
  'Boston Scientific': 'Boston',
  Biotronik: 'Biotronik',
  Sorin: 'Sorin',
}
